import {AccordionItem, TabsComponent} from '@/components/molecules'
import {LABELS} from '@/utils/constants/commonConstants'
import {
  SubItemDataTable,
  FulfillmentContent,
  AdjustmentsContent,
  TaxesInformationContent,
  ItemDiscountContent,
} from '@/containers'
import './SubItem/SubItemDataTable.scss'

const {ORDER_ITEM_OVERVIEW_PAGE} = LABELS || {}

export const SubItemAccordionContent = ({subItemAccordionData, itemDetails}) => {
  return (
    <AccordionItem
      label={ORDER_ITEM_OVERVIEW_PAGE.SubItems}
      isDark={true}
      content={<SubItemDataTable subItemAccordionData={subItemAccordionData} itemDetails={itemDetails} />}
    />
  )
}

export const TransactionDetailsAccordionContent = ({transactionDetailsData}) => {
  
  const { fulfillment, adjustments, taxesInformation} = transactionDetailsData || {}

  const tabList = [
    {
      id: 'fulfillment',
      tabLabel: 'Fulfillment',
      tabComponent: <FulfillmentContent fulfillmentData={fulfillment} />,
    },
    {
      id: 'adjustments',
      tabLabel: 'Adjustments',
      tabComponent: <AdjustmentsContent adjustmentsData={adjustments} />,
    },
    {
      id: 'taxesInformation',
      tabLabel: 'Taxes Information',
      tabComponent: <TaxesInformationContent taxesInformationData={taxesInformation} />,
    },
  ]

  return (
    <AccordionItem
      label={ORDER_ITEM_OVERVIEW_PAGE.TransactionDetails}
      isDark={true}
      content={
        <div>
          <TabsComponent tabList={tabList} defaultTabIndex={0} />
        </div>
      }
    />
  )
}

export const DiscountInformationAccordionContent = ({discountInfoList}) => {

  let tabList = []
  discountInfoList?.forEach((item, i) => {
    const tabObj = {
      id: 'itemDiscount_' + i,
      tabLabel: 'Item Discount ' + (i + 1),
      tabComponent: <ItemDiscountContent itemDiscountData={item} />,
    }
    tabList.push(tabObj)
  })

  return (
    <AccordionItem
      label={ORDER_ITEM_OVERVIEW_PAGE.DiscountInformation}
      isDark={true}
      content={
        <div>
          <TabsComponent tabList={tabList} defaultTabIndex={0} />
        </div>
      }
    />
  )
}
